import axios from  'axios'
const downloadImg = {
    imgs: document.querySelectorAll('.jsDownloadImg')  as NodeListOf<HTMLLinkElement>,   
  

    init() {
       this.downloadFn();

    },
    downloadFn() {
      this.imgs.forEach(item=>{
        
         axios.get(item.href)
         .then(res=>{
         
         })

      })
    }

}

export default downloadImg;
